import styled from '@emotion/styled';
import { FieldList } from '@hotjar/hotsauce';

export const StyledFieldList = styled(FieldList)`
  /* TODO remove when insights.scss is removed */
  label {
    margin-bottom: 0;
  }

  /* TODO remove when DS updates to set this padding */
  label {
    > span:first-of-type {
      padding: 3px;
    }

    > span:nth-of-type(2) {
      padding-top: 3px;
    }
  }
`;
